import React, { useEffect, Component, useCallback} from 'react';
import { getIsSelected} from './selectors.js';
import { connect } from "react-redux";
import {getBarWidth} from './getBarWidth.js';
import {getStepFromPosition} from './getStepFromPosition.js';
import {DEFAULT_RESOLUTION} from './constants.js';

function MouseHelper(props) {
    let style = {
        left: getBarWidth(
            props.cursorStep, props.resolution, props.xScale),
            
    };
    if (props.offset) {
        style.left += props.offset;
    }

    if (!props.isSelected) {
        style['display'] =  'none';
    }

    useEffect(() => {
        if (!props.sequencerEngine) {
            return;
        }
        if (!props.sequencerEngine.playing &&
            props.cursorStep !== undefined) {
            // then we seek to that
            props.sequencerEngine.seekToTrackStep(
                props.cursorStep);
        }
    }, [props.sequencerEngine, props.cursorStep]);

    return (
        <div className="flashit mouse-helper" style={style}></div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        mouseX: state.arrangement.mouseX,
        cursorStep: state.arrangement.cursorStep,
        resolution: DEFAULT_RESOLUTION,
        isSelected: props.isSelected || getIsSelected(state, props),
        xScale: state.arrangement.xScale,
    };
};
 
export default connect(mapStateToProps, null)(MouseHelper);
